import * as React from 'react';

type Props = {
  className?: string
}

export default ({ className }: Props) => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="16"
          viewBox="0 0 10 16"
          className={className}
        >
          <path d="M2.7 8l6.743-6.743L8.186 0 .815 7.371a.892.892 0 000 1.258L8.188 16l1.257-1.257L2.7 8z"></path>
        </svg>
    );
};
